
const state = {
    country_code:''
};

const getters = {
    getCountryCode: state => state.country_code,
};

const actions = {
    setCountryCode(context,country_code){
        context.commit('setCountryCode', country_code);
    },
};

const mutations = {
    setCountryCode: (state, country_code) => (state.country_code = country_code),
};

export default {
    state,
    getters,
    actions,
    mutations
}